import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import AdditionalQuestions from './AdditionalQuestions';
import { dateHelpers } from '@jauntin/utilities';
import { FOOD_VENDOR } from '../../Constants/constants';
import SelectWrap from '../SelectWrap';

const { numberOfDays } = dateHelpers;

const FoodField = ({ eventFood, eventDates, foodVendorsFrequency }) => {
  const [alertTrigger, setAlertTrigger] = useState(false);
  return (
    <>
      <label className="label">
        How many people selling food and/or beverages will be at your event,{' '}
        <i>that have not provided you with proof of insurance?</i>
      </label>
      <div className="label__subtext">
        For example, a concession stand or a hot dog cart run by a third party
        earning a profit. Caterers are not considered food vendors.
      </div>
      <div className="mw--130 mb-3">
        <Field
          name="eventFood"
          type="select"
          onChange={() => setAlertTrigger(false)}
          component={SelectWrap}
          {...{
            options: [
              { value: '0', label: '0' },
              { value: '1', label: '1' },
              { value: '2', label: '2' },
              { value: '3', label: '3' },
              { value: '4', label: '4' },
              { value: '5', label: '5' },
              { value: '6', label: '6' },
              { value: '7', label: '7 or more' },
            ],
          }}
        />
      </div>

      <AdditionalQuestions
        provider={FOOD_VENDOR}
        duration={numberOfDays(eventDates)}
        fieldArrayName="foodVendorsList"
        fieldArrayCount={Number(eventFood)}
        frequencyFieldName="foodVendorsFrequency"
        frequencyFieldValue={foodVendorsFrequency}
        alertTrigger={alertTrigger}
        setAlertTrigger={setAlertTrigger}
      />
    </>
  );
};
FoodField.propTypes = {
  eventDates: PropTypes.arrayOf(PropTypes.string).isRequired,
  eventFood: PropTypes.string.isRequired,
  foodVendorsFrequency: PropTypes.string.isRequired,
};

export default FoodField;
